import { queryOptions, useQuery } from '@tanstack/react-query';
import { learningApi } from '../infrastructure/api';

export const audienceKeys = {
  all: ['learning', 'audience'] as const,
  lesson: (lessonId: string) => [...audienceKeys.all, 'lesson', lessonId] as const,
  user: (userId: string) => [...audienceKeys.all, 'user', userId] as const,
};

export const audienceQuery = (lessonId: string) =>
  queryOptions({ queryKey: audienceKeys.lesson(lessonId), queryFn: () => learningApi.audience(lessonId) });

/** Quem assistiu a aula. Atualiza a cada 30 s enquanto a tela está aberta. */
export function useAudience(lessonId: string | undefined) {
  return useQuery({ ...audienceQuery(lessonId ?? ''), enabled: !!lessonId, refetchInterval: 30_000 });
}

export function useUserReport(userId: string | undefined) {
  return useQuery({
    queryKey: audienceKeys.user(userId ?? ''),
    queryFn: () => learningApi.userReport(userId!),
    enabled: !!userId,
  });
}
